"use client";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import {
  Box,
  ResponsiveValue,
  SimpleGrid,
  Stack,
  Tabs as ChakraTabs,
  TabPanels,
  TabPanel,
} from "@chakra-ui/react";

type Props = {
  columns?: ResponsiveValue<number>;
  tabList: {
    component: React.ComponentType;
    label: React.FunctionComponent<{ isSelected: boolean }>;
  }[];
};

const useHandleTab = () => {
  const searchParams = useSearchParams();
  const tab = searchParams.get("tab");
  const [tabIndex, setTabIndex] = useState(tab ? parseInt(tab) : 0);
  useEffect(() => {
    if (tab) {
      setTabIndex(parseInt(tab));
    }
  }, [tab]);
  return { tabIndex, setTabIndex };
};

const Tabs = (props: Props) => {
  const { columns = { base: 1, sm: 3 }, tabList } = props;
  const { tabIndex, setTabIndex } = useHandleTab();

  return (
    <Stack spacing={6} w="100%">
      <SimpleGrid columns={columns} spacing={2} w="full">
        {tabList.map((tab, index) => {
          const isSelected = index === tabIndex;
          const { label: Label } = tab;
          return (
            <Box
              bg={isSelected ? "primary.200" : "transparent"}
              borderColor="primary.200"
              borderRadius={"8px"}
              borderWidth={"1px"}
              boxSize={"border-box"}
              className="brand-shadow"
              color={isSelected ? "white" : "inherit"}
              cursor="pointer"
              key={index}
              minH={"3rem"}
              onClick={() => setTabIndex(index)}
              p={3}
              transition={"background-color 0.1s ease"}
              w="full"
              _hover={{ borderWidth: "1px" }}
            >
              <Label isSelected={isSelected} />
            </Box>
          );
        })}
      </SimpleGrid>
      <ChakraTabs index={tabIndex}>
        <TabPanels mt={8}>
          {tabList.map((tab, index) => {
            const { component: Component } = tab;
            return (
              <TabPanel key={index} p={0}>
                <Component />
              </TabPanel>
            );
          })}
        </TabPanels>
      </ChakraTabs>
    </Stack>
  );
};

export default Tabs;
